// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13234(456fc7c484)-C16/10/2026-07:20:19-B16/10/2026-07:30:58' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13234(456fc7c484)-C16/10/2026-07:20:19-B16/10/2026-07:30:58",
  branch: "test",
  latestTag: "8.1",
  revCount: "13234",
  shortHash: "456fc7c484",
  longHash: "456fc7c4842639a9aac90cd5f958d97a452c75ab",
  dateCommit: "16/10/2026-07:20:19",
  dateBuild: "16/10/2026-07:30:58",
  buildType: "Ansible",
  } ;
